import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  offset?: number;
  className?: string;
}
export function Reveal({
  children,
  delay = 0,
  offset = 18,
  className = ''
}: RevealProps) {
  const reduceMotion = useReducedMotion();
  if (reduceMotion) {
    return <div className={className} data-id="element-274" data-mp="3jny6k0vkb7w6">{children}</div>;
  }
  return <motion.div className={className} style={{
    willChange: 'opacity, transform'
  }} initial={{
    opacity: 0,
    y: offset
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.2
  }} transition={{
    duration: 0.45,
    delay,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-275" data-mp="35y313cvxf3n7">
      {children}
    </motion.div>;
}
interface PulseProps {
  className?: string;
}
export function Pulse({
  className = ''
}: PulseProps) {
  const reduceMotion = useReducedMotion();
  return <span className={`relative flex h-2.5 w-2.5 ${className}`} data-id="element-276" data-mp="2ryv32nbi21kl">
      {!reduceMotion && <motion.span className="absolute inset-0 rounded-full bg-brand" animate={{
      opacity: [0.6, 0, 0.6],
      scale: [1, 2.4, 1]
    }} transition={{
      duration: 2,
      repeat: Infinity,
      ease: 'easeOut'
    }} style={{
      willChange: 'opacity, transform'
    }} data-id="element-277" data-mp="1ztcs6uavag36" />}
      <span className="relative h-2.5 w-2.5 rounded-full bg-brand" data-id="element-278" data-mp="24sh5nx4tqzzb" />
    </span>;
}